import { render, staticRenderFns } from "./left_store_info.vue?vue&type=template&id=1febb21a&scoped=true&"
import script from "./left_store_info.vue?vue&type=script&lang=js&"
export * from "./left_store_info.vue?vue&type=script&lang=js&"
import style0 from "./left_store_info.vue?vue&type=style&index=0&id=1febb21a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1febb21a",
  null
  
)

export default component.exports